module.exports = __webpack_public_path__ + "media/images/athletes/2530-3c47066de49a8866aff12d09abcd336b.png";